module.exports = __webpack_public_path__ + "media/images/emblems/Ruth_Wappeni-e46d539ac2f3d1d29ebebcddc6f7457b.png";